import React, { Component } from "react";
import Skeleton from "@material-ui/lab/Skeleton";
import { connect } from "react-redux";

class LoadingCell extends Component {
  render() {
    const { language } = this.props;
    return (
      <div
        className="border row"
        style={{ backgroundColor: "white", padding: 11, alignItems: "center" }}
      >
        <div className="col" style={{ maxWidth: 60 }}>
          <Skeleton
            variant="rect"
            style={{
              borderRadius: 8,
              width: 40,
              height: 40,
              backgroundColor: "#c3c3c3",
              transform: "scale(0.91)",
              marginRight: language == "english" ? 10 : 5,
              marginLeft: language == "arabic" ? 10 : 5,
            }}
          />
        </div>
        <div className="col">
          <span>
            <Skeleton
              variant="text"
              style={{
                width: `${Math.floor(Math.random() * (70 - 30) + 30)}%`,
                backgroundColor: "#c3c3c3",
                position: "relative",
                top: -1,
              }}
            />
          </span>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    language: state.store.language,
  };
};

export default connect(mapStateToProps)(LoadingCell);
